import React from 'react';
import { usePlacesWidget } from 'react-google-autocomplete';

const LocationInput = ({
    name,
    placeholder = '',
    type = 'text',
    value,
    onChange,
    onPlaceSelected,
    error = '',
    required = false,
    className = '',
}) => {
    const { ref } = usePlacesWidget({
        apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        onPlaceSelected: (place) => {
            if (!place || !place.address_components) return;

            const getComponent = (type) =>
                place.address_components.find((component) => component.types.includes(type))
                    ?.long_name || '';

            const formattedAddress = {
                street: place.formatted_address, //`${getComponent('street_number')} ${getComponent('route')}`.trim(), // place.formatted_address
                city: getComponent('locality') || getComponent('sublocality') || '',
                state: getComponent('administrative_area_level_1'),
                zipcode: getComponent('postal_code'),
                country: getComponent('country'),
                lat: typeof place.geometry?.location?.lat === 'function' ? place.geometry.location.lat() : place.geometry?.location?.lat,
                lng: typeof place.geometry?.location?.lng === 'function' ? place.geometry.location.lng() : place.geometry?.location?.lng,
            };

            if (onPlaceSelected) {
                onPlaceSelected(formattedAddress);
            }
        },
        options: {
            types: ['address'],
            componentRestrictions: { country: 'us' },
        },
    });

    return (
        <div className={`w-full ${className}`}>
            <input
                ref={ref}
                name={name}
                type={type}
                placeholder={placeholder || 'Enter a location'}
                value={value}
                onChange={onChange}
                required={required}
                className={`w-full px-0 py-2 text-gray-900 bg-transparent border-0 border-b focus:outline-none focus:ring-0
                    ${error ? 'border-red-500' : 'border-gray-300'} 
                `}
            />
            {error && <p className='mt-1 text-xs text-red-500'>{error}</p>}
        </div>
    );
};

export default LocationInput;
